import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { black } from "@/theme/colors";
import { dayjs } from "@/utils/dayjs";

type TBillingCountInfoProps = {
  label: string;
  // Highest active-account count reached within the billing period.
  count?: number | null;
  // Date the count above was reached.
  date?: string | null;
};

// Cancels the Grid container spacing on the wrapping <Grid item>, so the block sits flush with the box edge.
// `!important` is required because Grid spacing is applied through a parent selector with higher specificity.
export const NO_PADDING_GRID_ITEM = { paddingTop: "0 !important", paddingLeft: "0 !important" };

export const BillingCountInfo: FC<TBillingCountInfoProps> = ({ label, count, date }) => {
  return (
    <Stack alignItems="center">
      <Typography variant="sub16Bold">{label}</Typography>
      <Typography variant="head24Bold" mt={1} mb={0.5}>
        {count ?? 0} 人
      </Typography>
      <Typography variant="body14" color={black[70]}>
        {date && dayjs(date).isValid() ? dayjs(date).format(DATE_FORMAT) : EMPTY_STR.DATE}
      </Typography>
    </Stack>
  );
};
